// ---------------------------------------------------------------------------
// Research Data
// ---------------------------------------------------------------------------
//
// Lab research and published/upcoming work.
// These are separate from publications — publications have full paper details
// and modals, research cards are simpler summaries.
//
// Add entries here as research projects become public.

const researchData = [];

export default researchData;
